import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import PriceVatDisclaimer from 'common/PriceVatDisclaimer';


const rows = [
  { product: 'Cintillo de Autoridad (Header de Alianza)', detail: 'Co-branding institucional', investment: '$80' },
  { product: 'Tecnología al Servicio del Mensaje', detail: 'Soluciones de conectividad', investment: '$120' },
  { product: 'Historias de Conexión', detail: '4 artículos al mes', investment: '$60' },
  { product: 'Tu Intención en la Red', detail: 'Widget de interacción', investment: '$150' },
  { product: 'Footer de Respaldo Institucional (despedida de los programas)', detail: 'Despedida de los programas', investment: '$80' },
];

const InvestmentSummary = () => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
          gutterBottom
          color="primary"
          align="center"
        >
          Resumen
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h4"
          gutterBottom
          align="center"
          color="primary"
        >
          Estructura de la alianza
        </Box>
      </Box>
      <TableContainer
        component={Paper}
        elevation={2}
        sx={{ maxWidth: 720, mx: 'auto', borderRadius: 2 }}
      >
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: theme.palette.primary.main }}>
              <TableCell sx={{ color: 'white', fontWeight: 700 }}>Componente</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 700 }}>Beneficio</TableCell>
              <TableCell align="right" sx={{ color: 'white', fontWeight: 700 }}>
                Inversión
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, i) => (
              <TableRow key={i} hover>
                <TableCell>{row.product}</TableCell>
                <TableCell>{row.detail}</TableCell>
                <TableCell align="right">{row.investment}</TableCell>
              </TableRow>
            ))}
            <TableRow sx={{ bgcolor: theme.palette.primary.light }}>
              <TableCell colSpan={2} sx={{ fontWeight: 700 }}>
                TOTAL MENSUAL
              </TableCell>
              <TableCell align="right" sx={{ fontWeight: 700 }}>
                $490
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <Box sx={{ maxWidth: 720, mx: 'auto', mt: 2, textAlign: 'center' }}>
        <Typography variant="body2" color="textSecondary">
          © TNO Network 2026 | Movistar & Punto de Fe | The Content Evolution.
        </Typography>
      </Box>
      <PriceVatDisclaimer />
    </Box>
  );
};

export default InvestmentSummary;
